import { render, staticRenderFns } from "./index.vue?vue&type=template&id=35cfbaa9&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=35cfbaa9&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35cfbaa9')) {
      api.createRecord('35cfbaa9', component.options)
    } else {
      api.reload('35cfbaa9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=35cfbaa9&", function () {
      api.rerender('35cfbaa9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/components/activitycontent/index.vue"
export default component.exports